import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { 
    Container, 
    Row, Col, Card, 
    CardBody, CardTitle, Table,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, Modal, Alert, Input, Button, Badge} from "reactstrap";
import { Link } from 'react-router-dom';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import axios from 'axios';
import { formatDate, HRConfig, TOAST_OPTIONS } from './../../helpers/backend_helper';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";
import { useHistory } from 'react-router-dom';

const FleetRequisitions = () => {
        const history = useHistory()
        const [pList, setPList] = useState([])
        const [modal, setmodal] = useState(false);
        const [modal_details, setmodal_details] = useState(false);
        const [isLoading, setIsLoading] = useState(false)
        const [empNo, setEmpNo] = useState('')
        const [empName, setEmpName] = useState('')
        const [empTitle, setEmpTitle] = useState('')
        const [postingDate, setPostingDate] = useState(new Date())
        const [skills, setSkills] = useState([])
        const [details, setDetails] = useState(null)

        toastr.options = TOAST_OPTIONS;

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_case = () => {
            setmodal(!modal);
            removeBodyCss();
        }
        const tog_details = () => {
            setmodal_details(!modal_details);
            removeBodyCss();
        }

        const [rows1, setrows1] = useState([{ id: 1 }]);

        const [formRows, setFormRows] = useState([{ id: 1 }]);

        const onAddFormRow = () => {
            const modifiedRows = [...formRows];
            modifiedRows.push({ id: modifiedRows.length + 1 });
            setFormRows(modifiedRows);
        };

        const onDeleteFormRow = id => {
            if (id !== 1) {
            var modifiedRows = [...formRows];
            modifiedRows = modifiedRows.filter(x => x["id"] !== id);
            setFormRows(modifiedRows);
            }
        };
        const handleClickDetails = (t) =>{
            setDetails(t)
            console.log(t)
            tog_details();
        }
        const handleCancelApproval = () =>{
            const data = {
                no: details.No
            }
            setIsLoading(true)
            axios.post(url.PDPCANCELAPPROVAL, data, HRConfig).then((r)=>{
                if(r.request.status == '204'){
                    toastr.success("Personal Development Plan Approval Cancelled")
                    tog_details()
                    getData()
                }else{
                    toastr.error("Could not Cancel")
                }
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                toastr.error(e.response.data.error.message)
                setIsLoading(false)
            })
        }
        const handleSubmit2Approve = () =>{
            const data = {
                no: details.No
            }
            setIsLoading(true)
            axios.post(url.PDPAPPROVAL, data, HRConfig).then((r)=>{
                if(r.request.status == '204'){
                    toastr.success("Personal Development Plan Sent For Approval")
                    tog_details()
                    getData()
                }else{
                    toastr.error("Could not Send Personal Development Plan For Approval")
                }
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                toastr.error(e.response.data.error.message)
                setIsLoading(false)
            })
        }
       

        const getData = () =>{
            setIsLoading(true)
            if (localStorage.getItem("authUser")) {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                setEmpNo(obj.uid)
                setEmpName(obj.username)
                axios.get(`${url.EMPLOYEES}?$filter=No eq '${obj.uid}'`, HRConfig).then((r)=>{ setEmpTitle(r.data.value[0].JobTitle)}).catch((e)=>{ console.log(e)})
            
                axios.get(`${url.PURCHASES1}?$filter=RequestByNo eq '${obj.uid}' &$expand=purchaseRequisitionLines`, HRConfig).then((r)=>{ 
                    setIsLoading(false)
                    setPList(r.data.value)
                    console.log(r.data.value)
                }).catch((e)=>{ console.log(e); setIsLoading(false); })
            }

        }
        useEffect(()=>{
           getData()
        },[])
        const { SearchBar } = Search;
        const columns = [
            {
              dataField: 'No',
              text: 'No',
              sort: true,
              formatter: noFormatter
            },
            {
              dataField: 'DocumentType', 
              text: 'Procurement Type',
              sort: true,
              formatter: typeFormatter
            }, 
            {
                dataField: 'EmployeeNo',
                isDummyField: true,
                text: 'Requisitioned By',
                sort: true,
                formatter: raisedByFormatter
              }, 
              {
                dataField: 'PositionCode',
                isDummyField: true,
                text: 'Location',
                sort: true,
                formatter: positionFormatter
              }, 
              {
                dataField: 'PostingDate',
                text: 'Workplan No',
                sort: true
              },             {
                dataField: 'PostingDate',
                text: 'Budget Code',
                sort: true
              }, 
            {
                dataField: 'purchaseRequisitionLines',
                isDummyField: true,
                text: 'Purchase Requisition Lines',
                sort: true,
                formatter: planFormatter
              },
              {
                dataField: 'Status',
                text: 'Status',
                sort: true,
                formatter: statusFormatter
              },
              {
                dataField: "action",
                isDummyField: true,
                text: "",
                formatter: actionFormatter
              }];
      
            const defaultSorted = [{
              dataField: 'No',
              order: 'desc'
            }];
      
            function planFormatter(cellContent,row){
              return(
                <span> <strong>{row.purchaseRequisitionLines.length}</strong></span>
              )
            }
            function raisedByFormatter(cellContent,row){
                return(
                  <span> {row.RequestByName}<br/>{row.RequestByNo}</span>
                )
              }
            function positionFormatter(cellContent, row){
              return(
                <span> {row.LocationCode}<br/>{row.ShortcutDimension1Code}<br/>{row.ShortcutDimension2Code}</span>
              )
            }
            function typeFormatter(cellContent, row){
                return(
                  <span> {row.SuppliesWorksServices}<br/>{row.SubjectOfProcurement}</span>
                )
              }
            function noFormatter(cellContent, row){
              return(
                <strong>{cellContent}</strong>
              )
            }
      
            function actionFormatter(cellContent, row){
              return(
                <>
                <div className="d-flex gap-3">
                <UncontrolledDropdown direction="left">
                    <DropdownToggle href="#" className="card-drop" tag="i">
                      <i className="mdi mdi-dots-horizontal font-size-18" />
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                 
                      <DropdownItem onClick={()=>{ history.push(`/fleet-requisition-details/${row.SystemId}`); }}
                      >
                        <i className="fas fa-address-card text-warning me-1" />
                        View Fleet Requisition Details
                      </DropdownItem>
                     
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </>
              )
            }
            function statusFormatter(cellContent, row) {
              if (row.Status == "Open") {
                return (
                  <div>
                      <Badge className="me-2 bg-danger">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if ((row.Status == "Approved") || (row.Status == "Released")){
                return (
                  <div>
                      <Badge className="me-2 bg-success">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if (row.Status == "Withdrawn(Cancelled)"){
                return (
                  <div>
                      <Badge className="me-2 bg-secondary">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else{
                return (
                  <div>
                      <Badge className="me-2 bg-warning">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }
            }
        
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Fleet Requisitions | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Fleet Management" breadcrumbItem="Fleet Requisitions" />
                        <Row>
                        <Col lg={12}>
                                {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                            </Col>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                               {(pList.length > 0) && (<>

                                    <ToolkitProvider
                                        keyField="No"
                                        data={ pList }
                                        columns={ columns }
                                        search
                                        >
                                        { toolkitProps => (
                                            <React.Fragment>
                                                <Row className='mb-5'>
                                                  <Col lg={8}>
                                                  <div  className="rounded bg-light d-grid gap-2">
                                           
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                 
                                                    </div>
                                                  </Col>
                                            
                                                  <Col lg={4}> 
                                                  <div className="d-grid gap-2">
                                                    <Link
                                                      className="btn btn-primary"
                                                      to="/create-fleet-requisition"
                                                    >
                                                      <i className="mdi mdi-plus me-1" />
                                                      Create fleet Requisition
                                                    </Link>
                                                  </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                <Col xl="12">
                                                    <div className="table">
                                                
                                                    <BootstrapTable 
                                                    keyField='No' 
                                                    data={ pList } 
                                                    columns={ columns } 
                                                    striped
                                                    hover
                                                    condensed
                                                    bordered={ false }
                                                    noDataIndication="No Records" 
                                                    defaultSorted={ defaultSorted }
                                                    classes={ "table align-middle table-nowrap table-check" }
                                                        {...toolkitProps.baseProps}
                                                    />
                                                </div>
                                                </Col>
                                                </Row>
                                                </React.Fragment>
                                                
                                        )
                                        }
                                    </ToolkitProvider>
                  

                              
                                </>)}
                                {(pList.length < 1) && (<>
                                    <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                
                                    
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-car-multiple text-primary display-4" />
                                        </div>
                                        <div>
                                        <h5>No Fleet Requisitions found</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>
                                    <div className="text-center mt-4">
                                        <Link
                                        to="/create-fleet-requisition"
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Create Requisition <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                              
                                </Col>
                            </Row>
                                </>)}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>
                           

                    </Container>
                </div>
            </>
        );
    }

export default FleetRequisitions;